import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforweddinginshirdi() {



    const cardData = {





keyword: "Bus Hire For Wedding in Shirdi",

headingDescription: "Sai Shirdi Cab provides reliable Bus Hire For Wedding in Shirdi for families, wedding parties, relatives, guests, and event groups traveling for weddings and related celebrations. Customers can arrange comfortable buses and group vehicles for guest pickup, hotel-to-venue transfers, railway station and airport transfers, local event transportation, and outstation wedding travel from Shirdi. Different seating capacities can be selected according to the number of guests, including suitable mini buses and larger 32, 35, 40, 45, and 50-seater options. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible schedules, and coordinated pickup and drop arrangements, Sai Shirdi Cab helps families manage wedding transportation efficiently. Buses can also be hired for multi-day wedding programs, destination weddings, reception events, family functions, and group sightseeing. Customers can customize the vehicle requirement according to guest count, venue locations, event timings, and the overall wedding itinerary.",

topPlaces: [
{
title: "Nashik",
description: "Nashik is a popular wedding destination from Shirdi with hotels, banquet halls, resorts, and event venues suitable for large family celebrations. Wedding groups can hire buses for transporting guests from Shirdi to Nashik and between hotels and venues. Larger seating capacities are useful when multiple relatives travel together."
},
{
title: "Pune",
description: "Pune is a major destination for weddings, receptions, and family functions, offering numerous banquet venues, hotels, and resorts. Families from Shirdi can arrange buses for coordinated guest transportation to Pune. Group travel helps keep wedding guests together while providing convenient transfers between accommodation and event venues."
},
{
title: "Mumbai",
description: "Mumbai has extensive wedding venues, luxury hotels, banquet halls, and event spaces suitable for large celebrations. Wedding parties traveling from Shirdi can hire buses for organized group transportation. Bus services can cover guest pickup, hotel transfers, venue travel, and return transportation according to the event schedule."
},
{
title: "Chhatrapati Sambhajinagar",
description: "Chhatrapati Sambhajinagar is a convenient wedding and family-function destination from Shirdi with hotels and event venues. Groups can hire buses for comfortable outstation travel and coordinated transfers during the celebration. Larger buses are suitable when relatives and wedding guests are traveling together."
},
{
title: "Kolhapur",
description: "Kolhapur is an important Maharashtra destination for traditional weddings, family functions, and celebrations. Wedding groups traveling from Shirdi can arrange bus hire for direct transportation to hotels and venues. Comfortable seating and luggage space make group travel practical for multi-day events."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular destination wedding location known for resorts, scenic surroundings, and event venues. Families can hire a bus from Shirdi to transport wedding guests to the destination. Multi-day bus rental can also cover hotel movements, wedding functions, sightseeing, and return travel."
},
{
title: "Lonavala",
description: "Lonavala is a preferred destination for resort weddings and family celebrations because of its scenic setting and event properties. Wedding parties from Shirdi can arrange buses for group transportation to the resort or venue. Flexible rental arrangements can cover multiple wedding functions throughout the stay."
},
{
title: "Satara",
description: "Satara offers hotels, resorts, and venues suitable for weddings and family celebrations. Guests traveling from Shirdi can hire a bus for comfortable group transportation and coordinated hotel-to-venue movements. The service is useful for families who want all wedding guests to travel together."
},
{
title: "Goa",
description: "Goa is a popular destination wedding location with beach resorts, hotels, and large celebration venues. Wedding groups from Shirdi can arrange bus transportation for long-distance travel and local guest movements. Multi-day rental can support airport transfers, hotel travel, wedding events, sightseeing, and return journeys."
},
{
title: "Indore",
description: "Indore is a major city suitable for weddings, receptions, and large family functions, with numerous hotels and event venues. Groups from Shirdi can hire a bus for organized long-distance transportation. Larger vehicles help accommodate relatives and guests traveling together with their wedding luggage."
},
{
title: "Ujjain",
description: "Ujjain is an important religious destination and can be included when wedding travel is combined with family pilgrimage or temple visits. Guests from Shirdi can hire a bus for comfortable group transportation to hotels, venues, and religious locations. Flexible scheduling helps accommodate wedding and pilgrimage activities."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal destination for private celebrations, resort weddings, and family events. Wedding groups traveling from Shirdi can arrange bus hire for direct transportation to their accommodation or venue. Group bus travel provides convenient coordination when several guests are attending the same event."
}
],








"services": [
{
"name": "Bus Hire For Wedding in Shirdi",
"description": "Bus Hire For Wedding in Shirdi provides convenient group transportation for wedding functions, ceremonies, and celebrations. Suitable buses can be arranged according to the number of wedding guests, travel schedule, pickup locations, venue requirements, luggage, and local or outstation transportation needs."
},
{
"name": "Wedding Bus Hire in Shirdi",
"description": "Wedding Bus Hire in Shirdi offers a practical transportation solution for families and guests attending wedding events. Bus arrangements can be planned for guest transfers, venue transportation, hotel pickups, railway station transfers, airport pickups, and other wedding-related travel requirements."
},
{
"name": "Wedding Bus Rental Shirdi",
"description": "Wedding Bus Rental Shirdi provides comfortable group travel arrangements for marriage functions and related events. Customers can select a suitable bus according to guest capacity, seating requirements, AC preference, journey duration, pickup points, and wedding itinerary."
},
{
"name": "Wedding Bus on Rent in Shirdi",
"description": "Wedding Bus on Rent in Shirdi is suitable for transporting groups of guests between hotels, homes, wedding venues, and other locations. Bus rental arrangements can be customized according to the wedding schedule, number of passengers, travel distance, and required vehicle capacity."
},
{
"name": "Marriage Bus Rental Shirdi",
"description": "Marriage Bus Rental Shirdi provides group transportation for families and guests attending marriage ceremonies in and around Shirdi. Vehicles can be arranged for venue transfers, guest movement, sightseeing, reception travel, and other transportation requirements during the wedding program."
},
{
"name": "Wedding Guest Bus Shirdi",
"description": "Wedding Guest Bus Shirdi helps families manage transportation for multiple guests attending wedding celebrations. Suitable buses can be organized for hotel-to-venue transfers, guest pickups, railway station transportation, airport transfers, and return journeys according to the event schedule."
},
{
"name": "Wedding Transportation Bus Shirdi",
"description": "Wedding Transportation Bus Shirdi provides organized group transportation for different wedding functions and celebrations. The service can accommodate guest movements between multiple locations with suitable seating capacity, pickup schedules, destination planning, and local or outstation travel options."
},
{
"name": "Wedding Tourist Bus Hire Shirdi",
"description": "Wedding Tourist Bus Hire Shirdi is suitable for families combining wedding events with local sightseeing or group travel. Tourist buses can be arranged for comfortable transportation between wedding venues, hotels, temples, tourist attractions, and other planned destinations."
},
{
"name": "Wedding Bus Booking Shirdi",
"description": "Wedding Bus Booking Shirdi allows families and event organizers to arrange group transportation in advance for marriage functions. Customers can provide the wedding date, passenger count, pickup locations, venue details, travel schedule, and preferred bus category while planning the booking."
},
{
"name": "Wedding Bus Service Shirdi",
"description": "Wedding Bus Service Shirdi offers private group transportation for guests and families attending wedding ceremonies. Bus services can be planned for complete event schedules, multiple pickups, venue transfers, hotel transportation, and return journeys based on the requirements of the wedding."
},
{
"name": "32 Seater Bus for Wedding Shirdi",
"description": "32 Seater Bus for Wedding Shirdi is suitable for wedding groups requiring organized transportation for a moderate number of guests. The bus can be arranged for venue transfers, family travel, guest pickups, local movement, and other wedding-related journeys according to the planned schedule."
},
{
"name": "35 Seater Bus for Wedding Shirdi",
"description": "35 Seater Bus for Wedding Shirdi provides group transportation for families and wedding guests traveling together. It can be arranged for hotel-to-venue transfers, wedding functions, reception transportation, local sightseeing, and other travel requirements with a planned pickup and drop schedule."
},
{
"name": "40 Seater Bus for Wedding Shirdi",
"description": "40 Seater Bus for Wedding Shirdi offers additional seating capacity for larger wedding groups. The bus can be booked for guest transportation between hotels, wedding venues, railway stations, airports, and other locations included in the wedding itinerary."
},
{
"name": "45 Seater Bus for Wedding Shirdi",
"description": "45 Seater Bus for Wedding Shirdi is designed for larger groups requiring comfortable transportation during wedding celebrations. Bus arrangements can be planned for guest transfers, family functions, reception events, venue changes, and return transportation based on passenger requirements."
},
{
"name": "50 Seater Bus for Wedding Shirdi",
"description": "50 Seater Bus for Wedding Shirdi provides high-capacity transportation for large wedding gatherings and extended families. The bus can be arranged for multiple guest pickups, venue transfers, hotel transportation, wedding functions, and other local or outstation travel requirements."
},
{
"name": "Luxury Bus Rental for Wedding Shirdi",
"description": "Luxury Bus Rental for Wedding Shirdi provides a premium group transportation option for families and guests attending special wedding functions. Luxury buses can be selected according to passenger capacity, comfort preferences, travel duration, event schedule, and required pickup and drop locations."
},
{
"name": "AC Bus Hire for Wedding Shirdi",
"description": "AC Bus Hire for Wedding Shirdi offers air-conditioned group transportation for guests traveling to wedding venues and related functions. Suitable AC buses can be arranged according to the number of passengers, journey duration, pickup locations, luggage requirements, and wedding itinerary."
},
{
"name": "Wedding Family Bus Rental Shirdi",
"description": "Wedding Family Bus Rental Shirdi provides convenient transportation for families traveling together for marriage celebrations. Bus arrangements can be organized for family members, relatives, and guests with suitable seating capacity, pickup points, venue transfers, and return travel requirements."
},
{
"name": "Wedding Baraat Bus Rental Shirdi",
"description": "Wedding Baraat Bus Rental Shirdi provides group transportation for family members and guests participating in wedding baraat celebrations. Suitable buses can be arranged according to group size, event timing, route, pickup location, destination venue, and additional transportation requirements."
},
{
"name": "Affordable Wedding Bus Hire Shirdi",
"description": "Affordable Wedding Bus Hire Shirdi provides a practical group transportation option for families looking to manage wedding travel expenses. Customers can select a suitable bus according to guest count, seating capacity, AC requirements, travel distance, event schedule, and local or outstation transportation needs."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab, taxi, and group transportation solutions for wedding functions and family events in Shirdi. Suitable options including sedans, Ertiga, Innova, Innova Crysta, Tempo Travellers, mini buses, and larger tourist buses can be arranged according to guest capacity and travel requirements."
}
],
"tableData": [
["Bus Hire For Wedding in Shirdi", "Wedding Bus Hire in Shirdi"],
["Wedding Bus Rental Shirdi", "Wedding Bus on Rent in Shirdi"],
["Marriage Bus Rental Shirdi", "Wedding Guest Bus Shirdi"],
["Wedding Transportation Bus Shirdi", "Wedding Tourist Bus Hire Shirdi"],
["Wedding Bus Booking Shirdi", "Wedding Bus Service Shirdi"],
["32 Seater Bus for Wedding Shirdi", "35 Seater Bus for Wedding Shirdi"],
["40 Seater Bus for Wedding Shirdi", "45 Seater Bus for Wedding Shirdi"],
["50 Seater Bus for Wedding Shirdi", "Luxury Bus Rental for Wedding Shirdi"],
["AC Bus Hire for Wedding Shirdi", "Wedding Family Bus Rental Shirdi"],
["Wedding Baraat Bus Rental Shirdi", "Affordable Wedding Bus Hire Shirdi"],
["Sai Shirdi Cabs", "Bus Hire For Wedding in Shirdi"]
]
,











    whychoose: [
        { 
            WhyChooseheading: "Bus Hire for Wedding in Shirdi for Group Transportation", 
            WhyChoosedescription: "Sai Shirdi Cabs provides wedding bus hire services in Shirdi for transporting relatives, friends, guests, and family members between hotels, wedding venues, railway stations, airports, temples, and other locations. Group bus transportation helps keep wedding travel organized and convenient." 
        }, 
        { 
            WhyChooseheading: "Convenient Transportation for Wedding Guests", 
            WhyChoosedescription: "Arrange dedicated buses for guests attending wedding functions in Shirdi. Group transportation can help families coordinate movements between accommodation locations and event venues without requiring every guest to arrange separate vehicles." 
        }, 
        { 
            WhyChooseheading: "Different Seating Capacity Options", 
            WhyChoosedescription: "Choose a suitable bus according to the size of your wedding group and transportation requirements. Options can include Mini Buses and larger 32, 35, 40, 45, and 50 Seater Buses depending on availability and group size." 
        }, 
        { 
            WhyChooseheading: "Hotel to Wedding Venue Transfers", 
            WhyChoosedescription: "Wedding buses can be arranged for repeated transfers between guest hotels, wedding halls, banquet venues, temples, residences, and other event locations. The transportation plan can be coordinated around the timing of your wedding functions." 
        }, 
        { 
            WhyChooseheading: "Useful for Multi-Function Wedding Events", 
            WhyChoosedescription: "Hire buses for different wedding functions such as engagement ceremonies, haldi, mehendi, wedding rituals, receptions, family gatherings, and other celebrations where group transportation is required." 
        }, 
        { 
            WhyChooseheading: "Suitable for Local & Outstation Guests", 
            WhyChoosedescription: "Guests travelling from nearby cities or other destinations can use group bus transportation for planned transfers within Shirdi. The service can also be discussed for outstation wedding travel based on the event itinerary." 
        }, 
        { 
            WhyChooseheading: "Comfortable Option for Large Families", 
            WhyChoosedescription: "Large families and wedding groups can travel together in a dedicated bus rather than arranging multiple smaller cars. This makes it easier to keep guests together and coordinate transportation during busy wedding schedules." 
        }, 
        { 
            WhyChooseheading: "Book Wedding Bus Hire in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your wedding date, guest count, pickup locations, venue details, function timings, number of buses required, seating capacity, and travel schedule with Sai Shirdi Cabs to arrange suitable wedding group transportation." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book a bus for a wedding in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides bus hire services in Shirdi for wedding guests, family members, relatives, friends, and group transportation requirements." 
    }, 
    { 
        question: "Can I hire a bus for wedding guests?", 
        answer: "Yes, wedding buses can be arranged to transport guests between hotels, wedding venues, railway stations, airports, temples, residences, and other planned locations." 
    }, 
    { 
        question: "Which bus sizes are available for weddings in Shirdi?", 
        answer: "Depending on availability, options can include Mini Buses and larger 32, 35, 40, 45, and 50 Seater Buses based on your group size and transportation requirements." 
    }, 
    { 
        question: "Can I hire a bus for multiple wedding functions?", 
        answer: "Yes, buses can be arranged for multiple functions such as engagement, haldi, mehendi, wedding ceremonies, reception, and other family events according to the planned schedule." 
    }, 
    { 
        question: "Can the bus pick up guests from different hotels?", 
        answer: "Multiple pickup locations can be discussed while planning the wedding transportation schedule, depending on the route, timing, and overall requirements." 
    }, 
    { 
        question: "Can I book a bus from the hotel to the wedding venue?", 
        answer: "Yes, wedding bus transportation can be arranged between guest hotels and the wedding venue according to the function timing and planned pickup schedule." 
    }, 
    { 
        question: "Can I hire a bus for outstation wedding guests?", 
        answer: "Yes, outstation wedding transportation can be discussed for guests travelling to Shirdi or other destinations based on the wedding itinerary and required travel arrangements." 
    }, 
    { 
        question: "Can I hire a bus for a large family wedding group?", 
        answer: "Yes, larger buses can be considered for big wedding groups so guests can travel together instead of arranging several separate cars." 
    }, 
    { 
        question: "Can wedding bus hire be arranged for multiple days?", 
        answer: "Yes, multi-day bus arrangements can be discussed for weddings requiring transportation across several functions, ceremonies, hotel transfers, and venue movements." 
    }, 
    { 
        question: "How can I book Bus Hire for Wedding in Shirdi with Sai Shirdi Cabs?", 
        answer: "Share your wedding date, guest count, pickup points, venue details, function timings, required seating capacity, number of buses, and travel schedule with Sai Shirdi Cabs to proceed with the booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Akshay Patil", 
        feedback: "We hired a bus for our family wedding in Shirdi and needed transportation between the guest hotel and venue. Having everyone travel together made the arrangements much easier during the wedding functions.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Rina Deshmukh", 
        feedback: "Our wedding had guests arriving from different places, so we arranged group bus transportation in Shirdi. It helped us coordinate hotel and venue transfers without asking every guest to arrange separate transport.", 
        rating: 5 
    } 
];


    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire For Wedding in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/bus-hire-for-wedding-in-shirdi.webp",
  "description":
    "Book Bus Hire For Wedding in Shirdi with Sai Shirdi Cabs for comfortable, reliable, and convenient wedding transportation for guests, family members, relatives, and groups. We provide wedding bus hire and rental services in Shirdi for marriage functions, wedding venues, receptions, guest pickup and drop, hotel transfers, and other wedding events. Choose from suitable bus and group transportation options with professional drivers, comfortable seating, convenient pickup and drop facilities, flexible rental packages, and dependable service for a smooth and organized wedding journey.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/bus-hire-for-wedding-in-shirdi"
  }
};




    return (
        <div>

<Helmet>
  <title>Bus Hire For Wedding in Shirdi | Wedding Bus Rental Shirdi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Bus Hire For Wedding in Shirdi with Sai Shirdi Cabs for comfortable wedding guest transportation. Hire buses for marriage functions, guest pickup and drop, hotel transfers, wedding venues and receptions with professional drivers, comfortable seating, flexible rental packages and reliable service."
  />

  <meta
    name="keywords"
    content="Bus Hire For Wedding in Shirdi, wedding bus hire in Shirdi, wedding bus rental Shirdi, wedding bus on rent in Shirdi, marriage bus rental Shirdi, wedding guest bus Shirdi, wedding transportation bus Shirdi, wedding tourist bus hire Shirdi, wedding bus booking Shirdi, Shirdi wedding bus booking, wedding bus service Shirdi, wedding bus hire Shirdi, wedding bus rental in Shirdi, marriage bus hire Shirdi, marriage bus on rent in Shirdi, marriage transportation bus Shirdi, wedding guest transportation Shirdi, wedding guest transport bus Shirdi, wedding guest bus rental Shirdi, wedding guest bus hire Shirdi, wedding guest pickup bus Shirdi, wedding guest drop bus Shirdi, wedding hotel transfer bus Shirdi, wedding venue bus Shirdi, wedding venue transportation Shirdi, wedding venue transfer bus Shirdi, wedding reception bus Shirdi, reception bus rental Shirdi, reception transportation Shirdi, marriage function bus Shirdi, marriage function bus rental Shirdi, marriage function transportation Shirdi, wedding event bus rental Shirdi, wedding event bus hire Shirdi, wedding transportation service Shirdi, wedding transport service Shirdi, Shirdi wedding transportation service, Shirdi wedding transport service, wedding group transportation Shirdi, wedding group bus Shirdi, wedding family bus Shirdi, wedding family transportation Shirdi, wedding tourist bus Shirdi, wedding tour bus rental Shirdi, wedding bus rental with driver Shirdi, wedding bus hire with driver Shirdi, marriage bus rental with driver Shirdi, wedding bus booking online Shirdi, online wedding bus booking Shirdi, wedding bus rental booking Shirdi, wedding bus hire booking Shirdi, affordable wedding bus rental Shirdi, best wedding bus hire Shirdi, reliable wedding bus service Shirdi, wedding bus rental price Shirdi, wedding bus hire charges Shirdi, wedding bus rental fare Shirdi, wedding transportation package Shirdi, wedding bus package Shirdi, wedding guest transportation package Shirdi, wedding bus for family Shirdi, wedding bus for relatives Shirdi, wedding bus for guests Shirdi, wedding bus for marriage ceremony Shirdi, wedding bus for reception Shirdi, wedding bus for baraat Shirdi, baraat bus rental Shirdi, baraat bus hire Shirdi, wedding procession bus Shirdi, wedding function transport Shirdi, wedding travel bus Shirdi, wedding outstation bus rental Shirdi, wedding outstation bus hire Shirdi, Shirdi wedding bus rental service, Shirdi wedding bus hire service, Shirdi marriage bus rental service, Shirdi marriage bus hire service, bus on rent for wedding in Shirdi, bus rental for marriage in Shirdi, bus hire for marriage in Shirdi, tourist bus on rent in Shirdi, tourist bus rental Shirdi, group bus rental Shirdi, group bus hire Shirdi, large group transportation Shirdi, wedding bus for outstation guests Shirdi, Shirdi wedding guest pickup and drop, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bushireforweddinginshirdi;